<template>
  <div>
    <el-row class="title">
      <el-col :span="24" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">订单销售额趋势</div>  <!--第三个图-->
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" class="panel-group">
      <el-col :span="24" class="card-panel-col">
        <bar-chart2 :data="data" :interval="100" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import barChart2 from "@/components/dashboard/charts/lineChart";

export default {
  components: {
    barChart2,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.title {
  .card-panel-col {
    border-bottom: solid 1px rgba(0, 0, 0, 0.03);
  }

  .card-panel {
    height: 50px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    z-index: 1;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);

    .card-panel-description {
      float: left;
      font-weight: bold;
      margin-left: 25px;

      .card-panel-text {
        line-height: 50px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 18px;
      }
    }
  }
}

.panel-group {
  // padding-left: 30px;
  .card-panel {
    margin: 20px 0;
    height: 108px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    // box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    // border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3;
    }

    .card-panel-icon-wrapper {
      float: left;
      // margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 72px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 20px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

// @media (max-width: 550px) {
//   .card-panel-description {
//     display: none;
//   }

//   .card-panel-icon-wrapper {
//     float: none !important;
//     width: 100%;
//     height: 100%;
//     margin: 0 !important;

//     .svg-icon {
//       display: block;
//       margin: 14px auto !important;
//       float: none !important;
//     }
//   }
// }
</style>
